module.exports = __webpack_public_path__ + "img/fallback-slide.1280x1280.en.c40be99d.png";